module.exports = "\r\n<div class=\"content\">\r\n<p>*********************************************************************</p>\r\n<div class=\"content\">\r\n  <router-outlet></router-outlet>\r\n</div>\r\n  \r\n</div>\r\n\r\n\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/stages/print-layout/print-layout.component.html
// module id = P3AU
// module chunks = 2